import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Alert, Button, ButtonGroup, Col, Form, OverlayTrigger, Popover, Row, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faBuildingCircleExclamation, faMoneyBill, faMoneyBillTransfer, faTriangleExclamation, faArrowDown, faArrowUp, faChevronDown, faChevronUp, faLock, faBan } from "@fortawesome/free-solid-svg-icons";
import _, { isNaN } from 'lodash';
import moment from 'moment';
import { HeaderList } from "../../components/HeaderList";
import { CustomModal } from "../../components/Modal";
import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import { DashboardBranchModel } from "../../models/dashboardBranch.model";
import { DashboardBranchService } from "../../services/dashboardBranch.service";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../models/requestInputOutputParams.model";
import { EquipmentModel } from "../../models/equipment.model";

import { BranchModel } from "../../models/branch.model";
import { BranchService } from "../../services/branch.service";

import { EquipmentService } from "../../services/equipment.service";
import { ToastService } from "../../services/toast.service";
import { UserService } from "../../services/user.service";
import { ModalAlertList } from "../../components/ModalAlertList";
import Select from 'react-select';
import Board, { moveCard } from "@lourenci/react-kanban";
// import '@asseinfo/react-kanban/dist/styles.css';
import './reactkanbam.css';
import { ButtonSearch, ButtonClean } from "../../components/buttons";
import DashboardService from "../../services/dashboard.service";
import ExternalBranchPickupService from "../../services/externalBranchPickup.service";
import PickupStatusService from "../../services/pickupStatus.service";
import { DropdownButtonExport } from "../../components/dropdownButton";
import { FileExportService } from "../../services/fileExport.service";
import { toast } from "react-toastify";
import Badge from 'react-bootstrap/Badge';
import ButtonInfo from "../../components/buttons/info";
import { ModalGeneralInformation } from "../../components/ModalGeneralInformation";
import ConfigService from "../../services/config.service";
import ButtonProgram from "../../components/buttons/program";

import { OptionProps } from 'react-select';
import { Left } from "react-bootstrap/lib/Media";
import storageService from "../../services/storage.service";
import HelperService from "../../services/helper.service";
import { CancellationRequestModal } from "../../components/CancellationRequestModal";
import { MultiEquipmentGroupService } from "../../services/multiequipmentgroup.service";

function CustomKanbanCard({ id, title, client, description, equipmentData, cardSelecteds, onCardClick, type, index,columnIndex, enableCard, showJustForced, balanceToLimitPercentage, monetaryToLimitPercentage, balanceOnlineValue, cardId, balanceToLimitPercentagePhysical, onlineBalancePhysicalLimitPercentage, balanceOnlinePhysicalValue }) {
    const { t } = useTranslation();
    const user = storageService.getUser();

    const flagPickupMonetaryLimit = equipmentData.flagPickupMonetaryLimit;
    const flagPickupPhysicalLimit = equipmentData.flagPickupPhysicalLimit;
    const flagPickupChangeRequired = equipmentData.flagPickupChangeRequired;
    const imposed = equipmentData.imposed;
    const imposedCashChange = equipmentData.imposed_cash_change;
    const statusRequestSigaCancellation = equipmentData.statusRequestSigaCancellation;

    const dayToImposition = equipmentData.days_to_imposition;

    const daysToImpositionCashChange = equipmentData.days_to_imposition_cash_change;

    if (showJustForced == 1 && !equipmentData.forced && !imposed) {
        return <div className="parentIgnore"></div>;
    }
    else if (showJustForced == 2 && (equipmentData.forced || imposed)) {
        return <div className="parentIgnore"></div>;
    }

    const containerStyle = { minHeight: '105px', cursor: 'pointer', borderColor: type === 'internal' ? (cardSelecteds.findIndex(x => x === id) > -1 ? '#830505' : null) : 'black', backgroundColor: type === 'internal' ? equipmentData.pickupStatusColor : '#fff' };
    var disabled = equipmentData.pickupStatusColor != '#96cbff';
    let exceedOnDay = false;
    if (type === 'internal') {
        switch (moment(equipmentData.pickupDate).day()) {
            case 0:
                exceedOnDay = equipmentData.exceedOnSunday;
                break;
            case 1:
                exceedOnDay = equipmentData.exceedOnMonday;
                break;
            case 2:
                exceedOnDay = equipmentData.exceedOnTuesday;
                break;
            case 3:
                exceedOnDay = equipmentData.exceedOnWednesday;
                break;
            case 4:
                exceedOnDay = equipmentData.exceedOnThursday;
                break;
            case 5:
                exceedOnDay = equipmentData.exceedOnFriday;
                break;
            case 6:
                exceedOnDay = equipmentData.exceedOnSaturday;
                break;
        }
    }
    const formatToCurrency = (value) => {
        let decimalSeparator = user.locale?.decimalSeparator;
        let thousandSeparator = user.locale?.thousandSeparator;
        let moneyPrefix = user.locale?.moneyPrefix;
        return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
    };
    return (
        <div className="noselect">
            <div className="react-kanban-card-container" data-cy={`${title}-${`d${String((columnIndex ?? 0) + 1).padStart(2, "0")}`}`} onMouseOver={() => enableCard(disabled)} onClick={() => { onCardClick(id) }} style={containerStyle}>
                <div className="react-kanban-card-inner">
                    <div className="clearfix">
                        {/* Título centralizado */}

                        <div className="kanban-card-header">
                            {/* Ícones à direita */}
                            <div className="kanban-card-icons">
                                {flagPickupPhysicalLimit && (
                                    <FontAwesomeIcon
                                        style={{ color: '#0039A6' }}
                                        title={`${t('CONFIG.PHYSICAL_LIMIT')}`}
                                        icon={faMoneyBillTransfer}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {flagPickupMonetaryLimit && (
                                    <FontAwesomeIcon
                                        style={{ color: '#0039A6' }}
                                        title={`${t('CONFIG.MONETARY_LIMIT')}`}
                                        icon={faMoneyBill}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {/* {imposed && (
                                    <FontAwesomeIcon
                                        style={{ color: 'red' }}
                                        title={`${t("DASHBOARD.IMPOSITION")} (${dayToImposition} ${t("DASHBOARD.DAYS")})`}
                                        icon={faTriangleExclamation}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {imposedCashChange && (
                                    <FontAwesomeIcon
                                        style={{ color: '#ff007f' }}
                                        title={`${t("DASHBOARD.IMPOSITION_CASH_CHANGE")} (${daysToImpositionCashChange} ${t("DASHBOARD.DAYS")})`}
                                        icon={faTriangleExclamation}
                                        className="kanban-card-icon"
                                    />
                                )} */}
                                {type === 'internal' && equipmentData.forced && !equipmentData.forced_cash_change && (
                                    <FontAwesomeIcon
                                        title={`${t("DASHBOARD_BRANCH.FORCED")} (${dayToImposition} ${t("DASHBOARD.DAYS")})`}
                                        style={{ color: 'red' }}
                                        icon={faTriangleExclamation}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {type === 'internal' && equipmentData.forced_cash_change && (
                                    <FontAwesomeIcon
                                        title={`${t("DASHBOARD.IMPOSITION_CASH_CHANGE")} (${daysToImpositionCashChange} ${t("DASHBOARD.DAYS")})`}
                                        style={{ color: '#FFC107' }}
                                        icon={faTriangleExclamation}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {type === 'internal' && exceedOnDay && (
                                    <FontAwesomeIcon
                                        style={{ color: '#0039A6' }}
                                        title={`${t('DASHBOARD.EXCEED')}`}
                                        icon={faBuildingCircleExclamation}
                                        className="kanban-card-icon"
                                    />
                                )}
                                {statusRequestSigaCancellation && (
                                    <FontAwesomeIcon
                                        style={{ color: 'red' }}
                                        title={`${t("DASHBOARD.CANCELLATION_REQUEST")}`}
                                        icon={faBan}
                                        className="kanban-card-icon"
                                    />
                                )}
                            </div>
                        </div>
                        {/* Título centralizado */}
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 250, hide: 400 }}
                            overlay={
                                <Popover id={`popover-${cardId}`}>
                                    <Popover.Body>
                                        {title} {/* Exibe o codigo completo do equipamento */}
                                    </Popover.Body>
                                </Popover>
                            }
                        >
                            <div className="react-kanban-card_sub_title kanban-card-center">
                                {title.substring(0, 9)} {/* Exibe os nove primeiros digitos do codigo do equipamento  */}
                            </div>
                        </OverlayTrigger>
                        {/* Texto centralizado "% Saldo atual" */}
                        <div className="kanban-card-center kanban-spacing black-text">
                            <strong>{t('DASHBOARD_BRANCH.PERC_BALANCE_ONLINE')}</strong>
                        </div>

                        {/* Ícone de seta e porcentagem centralizados */}
                        <div className="kanban-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="kanban-card-left kanban-spacing">
                                {balanceToLimitPercentage && typeof balanceToLimitPercentage === 'number' ? (
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                            <Popover id={`popover-${cardId}`}>
                                                <Popover.Header as="h3">{t('DASHBOARD_BRANCH.MONETARY_VALUE')}</Popover.Header>
                                                <Popover.Body>
                                                    {formatToCurrency(balanceOnlineValue)} {/* Exibe o valor de balanceOnlineValue */}
                                                </Popover.Body>
                                            </Popover>

                                        }
                                    >
                                        <div className="kanban-percentage-wrapper">
                                            {balanceToLimitPercentage > monetaryToLimitPercentage ? (
                                                <FontAwesomeIcon icon={faChevronUp} className="icon-small" style={{ color: 'black' }} />
                                            ) : (
                                                <FontAwesomeIcon icon={faChevronDown} className="icon-small" style={{ color: 'black' }} />
                                            )}
                                            <span className="percentage-large">{balanceToLimitPercentage}%</span> {/* Exibe a porcentagem completa */}
                                        </div>
                                    </OverlayTrigger>
                                ) : (
                                    <div className="kanban-percentage-wrapper">
                                        <span className="percentage-large">0%</span>
                                    </div>
                                )}
                            </div>
                            <div className="kanban-card-left kanban-spacing">
                                {balanceToLimitPercentagePhysical && typeof balanceToLimitPercentagePhysical === 'number' ? (
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                            <Popover id={`popover-${cardId}`}>
                                                <Popover.Header as="h3">{t('DASHBOARD_BRANCH.PHYSICAL_VALUE')}</Popover.Header>
                                                <Popover.Body>
                                                    {balanceOnlinePhysicalValue} {/* Exibe o valor de balanceOnlinePhysicalValue */}
                                                </Popover.Body>
                                            </Popover>

                                        }
                                    >
                                        <div className="kanban-percentage-wrapper">
                                            {balanceToLimitPercentagePhysical > onlineBalancePhysicalLimitPercentage ? (
                                                <FontAwesomeIcon icon={faChevronUp} className="icon-small" style={{ color: 'black' }} />
                                            ) : (
                                                <FontAwesomeIcon icon={faChevronDown} className="icon-small" style={{ color: 'black' }} />
                                            )}
                                            <span className="percentage-large">{balanceToLimitPercentagePhysical}%</span> {/* Exibe a porcentagem completa */}
                                        </div>
                                    </OverlayTrigger>
                                ) : (
                                    <div className="kanban-percentage-wrapper">
                                        <span className="percentage-large">0%</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Texto "Valor Monetário" centralizado */}
                        <div className="kanban-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div className="kanban-card-left kanban-spacing black-text">
                                {t('DASHBOARD_BRANCH.VALUE_MONETARY')}
                            </div>

                            <div className="kanban-card-right kanban-spacing black-text">
                                {t('DASHBOARD_BRANCH.VALUE_PHYSICAL')}
                            </div>
                        </div>



                    </div>
                    <span className="react-kanban-card__subtitle float-start mt-10">{client}</span>
                    <div className="react-kanban-description mt-10">{description}</div>
                </div>
            </div>
        </div>

    )
}

export const DashboardBranchList = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const [alertList, setAlertList] = useState([]);
    const [externalBranchPickupList, setExternalBranchPickupList] = useState([]);
    const [showModalGeneralInformation, setModalGeneralInformation] = useState(false);
    const [modalAlertListShow, setModalAlertListShow] = useState(false);
    const [filterForced, setFilterForced] = useState<number | null>(null);
    const user = storageService.getUser();

    const [datasetDashboardBranch, setDatasetDashboardBranch] = useState<DatasetModel>({
        ...JSON.parse(JSON.stringify(DatasetDefault)),
        dataset: 'dashboard_branch',
        filters: {
            id_equipment: [],
            pickup_date: [],
            branch_id: [],
            status_id: [],
            percentage_balance_online: null, // Adicionando a variável de porcentagem,
            customer: [],

        },
        pagination: {
            page_number: 1,
            total_pages: 1,
            records_pages: 100,
            total_records: 0
        },
    });

    const [kanbanColumnsData, setKanbanColumnData] = useState<Array<{ id: string, data: any }>>([]);
    const [desactiveProgramConfig, setDesactiveProgramConfig] = useState(true);
    const [equipments, setEquipments] = useState([]);
    const [statusValueSelected, setStatusValueSelected] = useState(null);
    const [equipmentSeleted, setEquipmentSeleted] = useState(null);
    const [branches, setBranches] = useState<BranchModel[]>();
    const [branchSeleted, setBranchSeleted] = useState(null);
    // Tipando o estado de percentageBalanceOnline como OptionType ou null
    const [percentageBalanceOnline, setPercentageBalanceOnline] = useState<number | null>(null);



    const [controlledBoard, setControlledBoard] = useState({ columns: [] });
    const [showJustificationModal, setShowJustificationModal] = useState({ show: false, justification: "", card: null, source: null, destination: null, alertMessage: '', color: '', disabled: false });
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [currentDay, setCurrentDay] = useState(new Date());
    const [cardSelecteds, setCardSelecteds] = useState([]);
    const [collectionForecastColor, setCollectionForecastColor] = useState('');
    const [inPlanCollectionServiceColor, setInPlanCollectionServiceColor] = useState('');
    const [planedCollectionServiceColor, setPlanedCollectionServiceColor] = useState('');
    const [scheduledCollectionServiceColor, setScheduledCollectionServiceColor] = useState('');
    const [executedCollectionServiceColor, setExecutedCollectionServiceColor] = useState('');
    const [showJustify, setShowJustify] = useState(false);
    const [percentMinimalValue, setPercentMinimalValue] = useState(20);
    const [percentMaxValue, setPercentMaxValue] = useState(100);
    const [movementCards, setMovementCards] = useState(true);
    const [flagClear, setFlagClear] = useState(false);
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    const [selectedEquipments, setSelectedEquipments] = useState([]);

    const [selectedEquipmentsForAssociationitems, setSelectedEquipmentsForAssociationitems] = useState([]);

    const [enableRecentPickupAlert, setEnableRecentPickupAlert] = useState(false);

    var reloadAfterClearAmount = 0;

    const getSquareColor = (value) => {
        let squareColor = 'gray';

        if (value === 1) {
            squareColor = '#96cbff';
        } else if (value === 4) {
            squareColor = '#efc88f';
        } else if (value === 7) {
            squareColor = '#c9c3ff';
        } else if (value === 12) {
            squareColor = '#FFFF99';
        }

        return squareColor;
    };

    const squareStyle = {
        width: '12px',
        height: '12px',
        marginLeft: '10px',
        marginRight: '10px',
        borderRadius: '3px',
        display: 'inline-block',
        cursor: 'default',
    };

    const CustomOption: React.FC<OptionProps<{ value: number, label: string }, false>> = ({ innerProps, label, data }) => {
        const [isHovered, setIsHovered] = useState(false);
        const squareColor = getSquareColor(data.value);
        const optionSquareStyle = { ...squareStyle, backgroundColor: squareColor };

        const optionStyle = {
            ...innerProps.style,
            cursor: 'default',
            backgroundColor: isHovered ? '#deebff' : 'transparent', // Altera a cor de fundo com base no estado de hover
        };

        return (
            <div
                {...innerProps}
                style={optionStyle}
                onMouseEnter={() => setIsHovered(true)} // Ativa o hover
                onMouseLeave={() => setIsHovered(false)} // Desativa o hover
            >
                <span style={optionSquareStyle}></span>
                <span>{label}</span>
            </div>
        );
    };

    const CustomValue = ({ data }) => {
        const squareColor = getSquareColor(data.value);
        const valueSquareStyle = { ...squareStyle, backgroundColor: squareColor };

        const labelStyle = {
            marginTop: '-20px',
            cursor: 'default',
        };

        return (
            <div style={labelStyle} >
                <span style={valueSquareStyle}></span>
                {data.label}
            </div>
        );
    };

    const handleCloseModalAlertList = () => {
        setModalAlertListShow(false);
    }

    const handleClean = () => {
        setEquipmentSeleted([]);

        setBranchSeleted([]);

        setStatusValueSelected([]);
        setFilterForced(null);
        setFlagClear(true);

        // Limpar o estado da porcentagem
        setPercentageBalanceOnline(null);
   
        // Limpar campos específicos do dataset
        setDatasetDashboardBranch(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                customer: [],
                percentage_balance_online: null
            },
            pagination: {
                ...prev.pagination,
                page_number: 1
            }
        }));
    };



    useEffect(() => {
        if (flagClear) {
            handleSearch();
            setFlagClear(false);
        }
    }, [flagClear]);

    const reloadAfterClear = () => {
        reloadAfterClearAmount++;
        if (reloadAfterClearAmount >= 3) {
            handleSearch();
        }
    }

    const fetchProgramEquipmentContingencyConfig = async () => {
        var response: any = await ConfigService.GetByKeyAndLocale(
            "PROGRAM_EQUIPMENT_CONTINGENCY"
        );
        if (response && response.success && response.result) {
            setDesactiveProgramConfig(response.result.configValue == "true");
        }
        else {
            setDesactiveProgramConfig(false);
        }

    };

    // Busca no config a chave ENABLE_RECENT_PICKUP_ALERT e atualiza o estado
    // indicando se o alerta de programação recente deve ser exibido.
    const fetchRecentPickupAlertConfig = async () => {
      const response: any = await ConfigService.GetByKeyAndLocale(
        "ENABLE_RECENT_PICKUP_ALERT"
      );
    
      if (response && response.success && response.result) {
        setEnableRecentPickupAlert(response.result.configValue === "true");
      } else {
        setEnableRecentPickupAlert(false);
      }
    };

    const showGeneralInformation = async () => {
        setModalGeneralInformation(true);
    }

    const handleCloseModalGeneralInformation = () => {
        setModalGeneralInformation(false);
    }

    const getList = async (date, datasetOverride = null) => {
        setLoading(true);

        let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride || datasetDashboardBranch] };

        if (date !== null && requestParams.datasets && requestParams.datasets[0]) {
            let pagination = requestParams.datasets[0].pagination;
            pagination.page_number = DatasetDefault.pagination.page_number;
            pagination.records_pages = 100;

            let filters = requestParams.datasets[0].filters;

            if (Array.isArray(date)) {
                filters.pickup_date = date;
            } else {
                filters.pickup_date = [moment(date).format("YYYY-MM-DD")];
            }

            if (equipmentSeleted != null) {
                filters.id_equipment[0] = equipmentSeleted.value;
            }

            if (branchSeleted != null) {
                filters.branch_id[0] = branchSeleted.value;
            }

            if (statusValueSelected != null) {
                filters.status_id[0] = statusValueSelected.value;
            }

            // Passar o valor de percentageBalanceOnline como parte dos filtros
            if (percentageBalanceOnline !== null) {
                filters.percentage_balance_online = percentageBalanceOnline;
            } else {
                // Certifique-se de que o filtro seja removido quando o valor for nulo
                delete filters.percentage_balance_online;
            }

        }

        const response: any = await DashboardBranchService.getList(requestParams);

        let dsModelDashboardBranch: DatasetModel;

        if (response.success === true && response.result) {
            dsModelDashboardBranch = _.last(_.filter(response.result.datasets, { dataset: "dashboard_branch" }));
        }

        setLoading(false);

        return dsModelDashboardBranch;
    };

    const getExternalBranchPickupList = async (startDate, totalDays) => {
        const response: any = await ExternalBranchPickupService.GetListByPeriod(startDate, totalDays);

        let dsModelExternalBranchPickup: DatasetModel;

        if (response.success === true && response.result) {
            dsModelExternalBranchPickup = _.last(_.filter(response.result.datasets, { dataset: "external_branch_pickup" }));
            setExternalBranchPickupList(dsModelExternalBranchPickup?.data);
        } else {
            setExternalBranchPickupList([]);
        }
    };

    useEffect(() => {
        const startDate = moment(currentDay).format("YYYY-MM-DD");
        getExternalBranchPickupList(startDate, 7);

    }, [currentDay]);

    const handleSearch = async () => {
        const dates = Array.from({ length: 7 }, (_, i) => moment(currentDay).add(i, "days"));
        const formattedDates = dates.map(date => date.format("YYYY-MM-DD"));


        const trimcustomer = datasetDashboardBranch.filters.customer?.[0]?.trim() || "";

        const cleanedDataset = {
        ...datasetDashboardBranch,         // objeto principal
        filters: {
            ...datasetDashboardBranch.filters,  // filtros atuais
            customer: [trimcustomer],             // substitui o filtro customer pelo valor trimado
        },
        };

        // Chamada da API passando todas as datas em um único array
        const dataset = await getList(formattedDates, cleanedDataset);
        //const dataset = await getList(formattedDates);

        const kanbanColumnDataAux = [];

        dates.forEach((newDate) => {
            const formattedDate = newDate.format("YYYY-MM-DD");

            // Filtra os dados para incluir apenas aqueles que possuem pickupDate igual à data atual
            const filteredData = (dataset?.data || []).filter(item =>
                moment(item.pickupDate).format("YYYY-MM-DD") === formattedDate
            );

            kanbanColumnDataAux.push({
                id: formattedDate,
                data: filteredData
            });
        });

        const currentColumns = kanbanColumnDataAux.map((item, index) =>
            generateKanbanColumn(item.data, moment(item.id, "YYYY-MM-DD").toDate(), index)
        );

        // Atualiza o estado
        setKanbanColumnData([...kanbanColumnDataAux]);
    }

    const renderFriendlyExternal = (cardId, item) => {
        if (!item.destination_address) return "";
        const formattedAddress = item.destination_address.length > 40 ? item.destination_address.substring(0, 40) + "..." : item.destination_address
        const valueStyle = { color: 'red' };
        return (<OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
                <Popover id={`popover-${cardId}`}>
                    <Popover.Header as="h3">{t("DASHBOARD_BRANCH.FULL_ADDRESS")}</Popover.Header>
                    <Popover.Body>
                        <div>{t('DASHBOARD_BRANCH.TYPE_SERVICE')}: <b style={valueStyle}>{item.transportation_type}</b></div>
                        <div>{t('DASHBOARD_BRANCH.CODE')}: <b style={valueStyle}>{item.id}</b></div>
                        <div>{t('DASHBOARD_BRANCH.QTD')}: <b style={valueStyle}>{item.itens_count}</b> / {t('DASHBOARD_BRANCH.ROUTE')}: <b style={valueStyle}>{item.route_code}</b></div>
                        <div>{item.destination_name}</div>
                        <div>{item.destination_address} {item.destination_district_address} {item.destination_city_address}</div>
                        <div>{item.destination_state_address} </div>
                    </Popover.Body>
                </Popover>
            }
        >
            <span style={{ color: 'black' }}>{formattedAddress}</span>
        </OverlayTrigger>)
    }

    const renderFriendlyEquipmentAddress = (cardId, item) => {
        if (!item.equipmentAddress) return "";

        const formattedAddress = item.equipmentAddress.length > 40 ? item.equipmentAddress.substring(0, 40) + "..." : item.equipmentAddress

        return (<OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
                <Popover id={`popover-${cardId}`}>
                    <Popover.Header as="h3">{t("DASHBOARD_BRANCH.FULL_ADDRESS")}</Popover.Header>
                    <Popover.Body>
                        {item.equipmentAddress}
                    </Popover.Body>
                </Popover>
            }
        >
            <span style={{ color: 'black' }}>{formattedAddress}</span>
        </OverlayTrigger>)
    }

    const renderNameCut = (cardId, item) => {

        if (!item.clientComercialName) return "";

        const formattedName = item.clientComercialName.length > 20 ? item.clientComercialName.substring(0, 20) + "..." : item.clientComercialName

        return (<OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 400 }}
            overlay={
                <Popover id={`popover-${cardId}`}>
                    <Popover.Header as="h3">{t("USER.FULLNAME")}</Popover.Header>
                    <Popover.Body>
                        {item.clientComercialName}
                    </Popover.Body>
                </Popover>
            }
        >
            <span style={{ color: 'black' }}>{formattedName}</span>
        </OverlayTrigger>)
    }

    const generateKanbanColumn = (dashboardData: any[], date: Date, columnIndex: number = 0) => {
        let kanbanCards = [];
        if (dashboardData) {
            kanbanCards = dashboardData.map(item => {
                const cardId = `cardId__${item.idEquipment || (item.id + Math.random())}__${moment(item.pickupDate).format("YYYY-MM-DD")}__${item.codeEquipment}__${item.statusRequestSigaCancellation}__${item.pickupStatusColor}__${item.idEquipmentPickup}`;
                return {
                    id: cardId,
                    cardId: cardId,  // Passando o cardId
                    title: `${item.codeEquipment || item.id}`,
                    columnIndex: columnIndex,
                    balanceToLimitPercentage: item.balanceToLimitPercentage,
                    monetaryToLimitPercentage: item.monetaryToLimitPercentage,
                    balanceOnlineValue: item.balanceOnlineValue,
                    description: <>{item.idEquipment ? renderFriendlyEquipmentAddress(cardId, item) : renderFriendlyExternal(cardId, item)}</>,
                    client: <>{item.clientComercialName ? renderNameCut(cardId, item) : renderNameCut(cardId, item)}</>,
                    equipmentData: item,
                    type: item.idEquipment ? 'internal' : 'external',
                    disableCardDrag: item.idEquipment ? true : false,
                    balanceToLimitPercentagePhysical: item.balanceToLimitPercentagePhysical,
                    onlineBalancePhysicalLimitPercentage: item.onlineBalancePhysicalLimitPercentage,
                    balanceOnlinePhysicalValue: item.balanceOnlinePhysicalValue,
                };
            });
        }

        const momentDate = moment(date);

        return {
            id: `columnId__${momentDate.format("YYYY-MM-DD")}`,
            title: (<div>{t(momentDate.format("dddd").toUpperCase())}<span className="fw-normal">{momentDate.format('DD/MM')}</span></div>),
            cards: kanbanCards
        };
    }

    const updateBoardColumnCardId = (board: any, destinationColumnId: string, currentCardId: string) => {
        const columnDestination = board.columns.find((x: any) => x.id === destinationColumnId);
        columnDestination.cards = columnDestination.cards.map(item => {
            if (item.id === currentCardId) {
                const pickupDateTo = destinationColumnId.split("__")[1];
                const newId = `${item.id.split("__")[0]}__${item.id.split("__")[1]}__${pickupDateTo}`;
                item.id = newId;
            }
            return item;
        });
    }

      async function fetchAssociations(ids) {
        try {
          const response = await  MultiEquipmentGroupService.getAllById(ids);
          // Aqui o resultado real da API está dentro de response.data
          const result = response.result; // conforme seu backend
    
          if (!Array.isArray(result)) {
            console.error('Formato inesperado da resposta:', result);
            return;
          }

          const mapped = result.map(item => ({
            equipment: Number(item.equipment),
            associated: item.associated.map(Number)
          }));
    
          setSelectedEquipmentsForAssociationitems(mapped);
        } catch (error) {
          console.error('Erro ao buscar associações:', error);
        }
      }

    const handleChangeJustification = (evt: any) => {
        setShowJustificationModal({ ...showJustificationModal, justification: evt.target.value });
    }

    const handleCloseModal = () => {
        setShowJustificationModal({ show: false, justification: "", card: null, source: null, destination: null, color: '', alertMessage: '', disabled: false });
        setShowScheduleModal(false);
    }

    const handleProgramClick = async () => {
        if (kanbanColumnsSelected().length == 0 && kanbanColumnsSelectedProgrammingSequence().length > 0) {

            saveEquipmentProgram();
        }
        else {
            // const pickupselected = cardSelecteds.map(item => {
            //     const itemSplitted = item.split("__");
            //     return {
            //         id_equipment: itemSplitted[1],
            //     }
            // });
            const ids = cardSelecteds.map(item => item.split("__")[1]);
            await fetchAssociations(ids);
            //await fetchAssociations([200]);
            setShowScheduleModal(true);
        };
    };

    useEffect(() => {
        console.log('Equipamentos associados atualizados:', selectedEquipmentsForAssociationitems);
    }, [selectedEquipmentsForAssociationitems]);


    const handleChangeEquipment = (selectedOption) => {
        setEquipmentSeleted(selectedOption)
    };

    const handleChangeBranch = (selectedOption) => {
        setBranchSeleted(selectedOption)
    };

    const handleChangeStatusValue = (selectedOption) => {
        setStatusValueSelected(selectedOption);
    };


    const saveEquipmentProgram = async () => {
        setLoading(true);

        const pickupStatusData = cardSelecteds.map(item => {
            const itemSplitted = item.split("__");
            return {
                id_equipment: itemSplitted[1],
                pickup_date: itemSplitted[2],
                dash_action: "PROGRAM",
                pickup_change_required: listChangeSelect.some((f) => f === item)
            }
        });

        let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [{
                ...DatasetDefault,
                dataset: 'dashboard_branch_pickupstatus',
                data: pickupStatusData
            }]
        };



        const response: any = await DashboardBranchService.updateEquipmentPickupStatus(requestParams);

        if (response.success === true && response.result) {
            const dataset = _.last(_.filter(response.result.datasets, { dataset: "dashboard_branch" }));

            if (dataset?.data) {
                for (let i = 0; i < dataset.data.length; i++) {
                    updateCardByData(dataset.data[i]);
                }
            }
            ToastService.success(t('DASHBOARD_BRANCH.SCHEDULE_SUCCESS'));
        }

        setCardSelecteds([]);
        setLoading(false);
        handleCloseModal();
    }

    

    const saveJustification = async () => {
        setLoading(true);

        if (showJustificationModal) {
            const currentCardMovement = {
                justification: showJustificationModal.justification,
                card: showJustificationModal.card,
                source: showJustificationModal.source,
                destination: showJustificationModal.destination
            };

            const response: any = await DashboardBranchService.updateEquipmentPickupDate({
                auth: null,
                datasets: [
                    {
                        dataset: "dashboard_branch_pickupdate",
                        data: [{
                            id_equipment: currentCardMovement.card.equipmentData.idEquipment,
                            pickup_date_from: currentCardMovement.source.fromColumnId.split("__")[1],
                            pickup_date_to: currentCardMovement.destination.toColumnId.split("__")[1],
                            pickup_observation: currentCardMovement.justification,
                            id_equipment_pickup: currentCardMovement.card.equipmentData.idEquipmentPickup
                        }]
                    }
                ]
            });

            if (response.success === true && response.result) {
                const updatedBoard = moveCard(controlledBoard, currentCardMovement.source, currentCardMovement.destination);
                // Update card id
                updateBoardColumnCardId(updatedBoard, currentCardMovement.destination.toColumnId, currentCardMovement.card.id);
                setControlledBoard(updatedBoard);
                let datasets = _.last(_.filter(response.result.datasets, { dataset: "dashboard_branch" }));
                if (datasets?.data) {
                    updateCardByEquipmentId(datasets.data, currentCardMovement.card.equipmentData.idEquipment);
                }
            }
        }

        handleSearch();
        setLoading(false);
        handleCloseModal();
    }

    const handleCardMove = (card: any, source: any, destination: any) => {
        //if (card.equipmentData.pickupStatusId === 1 && 
        setLoading(true);

        DashboardBranchService.getChangeDay(card.equipmentData.idEquipment, card.equipmentData.pickupDate).then((response: any) => {
            if (response && response.success) {

                let respData = _.last(_.filter(response.result.datasets, { dataset: "dashboard_core" }));
                if (respData.data.length > 0) {

                    let d = respData.data[0];


                    //NOTE: Define valor percentual
                    const moment = require('moment');
                    let currentDate = moment().startOf('day');
                    let dayTo = moment(destination.toColumnId.split("__")[1], "YYYY-MM-DD");
                    let dayColumn = dayTo.diff(currentDate, 'days') + 1;
                    let dayValue = d[`d0${dayColumn}Value`];
                    let requiresJustification = false;

                    let percentualValue = d.limitContractual && Number(d.limitContractual) > 0 ? (Number(dayValue) / Number(d.limitContractual)) * 100 : 0;
                    let color = "success";

                    let alertMessage = t("DASHBOARD_BRANCH.ALERT_SUCCESS_LIMIT").replaceAll('<< ##,##% >>', `${percentualValue.toFixed(0)}%`);

                    if (isNaN(percentualValue)) {
                        percentualValue = 0;
                    }
                    //NOTE: Demonstrar campo justificativa
                    if (percentualValue >= percentMaxValue) {
                        color = "danger";
                        alertMessage = t("DASHBOARD_BRANCH.ALERT_DANGER_LIMIT").replaceAll('<< ##,##% >>', `${percentualValue.toFixed(0)}%`);
                        setShowJustify(true);
                        requiresJustification = true;
                    } else if (percentualValue <= (d.limitMonetary / d.limitContractual * 100) - percentMinimalValue) {
                        color = "warning";
                        alertMessage = t("DASHBOARD_BRANCH.ALERT_WARNING_LIMIT").replaceAll('<< ##,##% >>', `${percentualValue.toFixed(0)}%`);
                        setShowJustify(true);
                        requiresJustification = true;
                    }
                    else {
                        setShowJustify(false);
                    }

                    if (source.fromColumnId != destination.toColumnId) { // Pode ser movimentado
                        setShowJustificationModal({ ...showJustificationModal, show: requiresJustification, card: card, source: source, destination: destination, color, alertMessage, disabled: percentualValue > percentMaxValue || percentualValue < percentMinimalValue });
                    }
                }
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        if (showJustificationModal.card && showJustificationModal.destination) {
            if (!showJustify) {
                saveJustification();
            }
        }
    }, [showJustificationModal]);


    const renderPeriodDescriptionFake = (add) => {
        const currentDate = moment(currentDay).add(add, "days");;
        return <><strong>{t(currentDate.format('dddd').toUpperCase())}</strong><br /><span className="fw-normal">{currentDate.format('DD/MM')}</span></>
    }

    const enableCard = (disabled: boolean) => {
        setMovementCards(disabled);
        return true;
    }

    const renderPeriodDescription = () => {
        const currentDate = moment(currentDay);
        const currentDatePlusDays = moment(currentDay).add(6, "days");

        return <><strong>{t(currentDate.format('MMMM').toUpperCase())}</strong> {currentDate.date()} - {currentDatePlusDays.date()}</>
    }

    const handleCardClick = (cardId: any) => {
        const exists = cardSelecteds.find(x => x === cardId);
        if (exists) {
            setCardSelecteds(cardSelecteds.filter(x => x !== cardId));
        }
        else {
            setCardSelecteds([...cardSelecteds, cardId]);
        }
    }

    const addDayToPeriod = async (value) => {
        // TODO: Verificar se o dia minimo e máximo precisa ser atualizado na consulta;

        const newCurrentDay = moment(currentDay).add(value, "days").toDate();
        setCurrentDay(newCurrentDay);

        updateColumnByDate(newCurrentDay);
    }

    const findExternalBranchPickupByDate = (dataValue: any, date: any) => {
        return moment(dataValue.service_datetime).isSame(date.format("YYYY-MM-DD"));
    }

    const createInitialBoard = async () => {

        const dates = Array.from({ length: 7 }, (_, i) => moment(currentDay).add(i, "days"));
        const formattedDates = dates.map(date => date.format("YYYY-MM-DD"));

        // Chamada da API passando todas as datas em um único array
        const dataset = await getList(formattedDates);

        const kanbanColumnDataAux = [];

        dates.forEach((newDate) => {
            const formattedDate = newDate.format("YYYY-MM-DD");

            // Filtra os dados para incluir apenas aqueles que possuem pickupDate igual à data atual
            const filteredData = (dataset?.data || []).filter(item =>
                moment(item.pickupDate).format("YYYY-MM-DD") === formattedDate
            );

            kanbanColumnDataAux.push({
                id: formattedDate,
                data: filteredData
            });
        });

        const currentColumns = kanbanColumnDataAux.map((item, index) =>
            generateKanbanColumn(item.data, moment(item.id, "YYYY-MM-DD").toDate(), index)
        );        

        // Atualiza o estado
        setKanbanColumnData([...kanbanColumnDataAux]);
    }

    const updateColumnByDate = async (date) => {
        const kanbanColumnDataAux = Object.assign([], kanbanColumnsData);
        const momentDate = moment(date);

        const dataset = await getList(date);
        let kanbanColumn = kanbanColumnDataAux.find(x => x.id === momentDate.format("YYYY-MM-DD"));

        if (kanbanColumn) {
            kanbanColumn.data = dataset?.data;
        }
        else {
            kanbanColumnDataAux.push({
                id: momentDate.format("YYYY-MM-DD"),
                data: dataset?.data
            });
        }

        setKanbanColumnData(kanbanColumnDataAux);
    }

    const updateCardByEquipmentId = (equipmentsData: DashboardBranchModel[], idEquipment: number) => {
        const kanbanColumnDataAux = Object.assign([], kanbanColumnsData);

        kanbanColumnDataAux.map((column) => {
            _.remove(column.data, (equipment: any) => { return equipment.idEquipment === idEquipment });
        });

        equipmentsData.map((equipmentData) => {
            let dataColumn = _.find(kanbanColumnDataAux, { id: moment(equipmentData.pickupDate).format("YYYY-MM-DD") });
            if (dataColumn) {
                if (!dataColumn.data) {
                    dataColumn.data = [];
                }
                dataColumn.data.push(equipmentData);

            } else {
                kanbanColumnDataAux.push({ id: moment(equipmentData.pickupDate).format("YYYY-MM-DD"), data: [equipmentData] });
            }
        });

        setKanbanColumnData(kanbanColumnDataAux);
    }

    const updateCardByData = (equipmentData: DashboardBranchModel) => {
        const kanbanColumnDataAux = Object.assign([], kanbanColumnsData);

        const kanbanColumn = kanbanColumnDataAux.find(kanbanColumn => kanbanColumn.id === moment(equipmentData.pickupDate).format("YYYY-MM-DD"));
        const newKanbanColumnCards = kanbanColumn?.data?.map(kanbanColumnCard => {
            if (kanbanColumnCard.idEquipment === equipmentData.idEquipment && kanbanColumnCard.pickupDate === equipmentData.pickupDate) {
                kanbanColumnCard = equipmentData;
            }
            return kanbanColumnCard;
        });
        kanbanColumn.data = newKanbanColumnCards;
        setKanbanColumnData(kanbanColumnDataAux);
    }

    const kanbanColumnsSelectedProgrammingSequence = () => {
        const kanbanColumnsSelectedAuxDate = [];
        const kanbanColumnsSelectedAux = [];

        for (var i = 0; i < cardSelecteds.length; i++) {
            const SelectedAux = cardSelecteds[i].split("__");
            kanbanColumnsSelectedAuxDate.push({ id: parseInt(SelectedAux[1]), dataid: SelectedAux[2] });
        }

        const kanbanColumnsFilteredDate = kanbanColumnsData.filter((el) => {
            return kanbanColumnsSelectedAuxDate.some((f) => {
                return f.dataid === el.id;
            });
        })

        for (var i = 0; i < kanbanColumnsFilteredDate.length; i++) {

            const SelectedAux = kanbanColumnsFilteredDate[i].data;

            const filter = SelectedAux.filter((el) => {
                return kanbanColumnsSelectedAuxDate.some((f) => {
                    return f.id === el.idEquipment;
                });
            })

            for (var ii = 0; ii < filter.length; ii++) {
                if (filter[ii].flagEquipmentProgrammingSequence == true) {
                    kanbanColumnsSelectedAux.push(filter[ii]);
                }
            }
        }
        return kanbanColumnsSelectedAux;

    }

    const kanbanColumnsSelected = () => {
        const kanbanColumnsSelectedAuxDate = [];
        const kanbanColumnsSelectedAux = [];

        for (var i = 0; i < cardSelecteds.length; i++) {
            const SelectedAux = cardSelecteds[i].split("__");
            kanbanColumnsSelectedAuxDate.push({ id: parseInt(SelectedAux[1]), dataid: SelectedAux[2] });
        }

        const kanbanColumnsFilteredDate = kanbanColumnsData.filter((el) => {
            return kanbanColumnsSelectedAuxDate.some((f) => {
                return f.dataid === el.id;
            });
        })

        for (var i = 0; i < kanbanColumnsFilteredDate.length; i++) {

            const SelectedAux = kanbanColumnsFilteredDate[i].data;

            const filter = SelectedAux.filter((el) => {
                return kanbanColumnsSelectedAuxDate.some((f) => {
                    return f.id === el.idEquipment;
                });
            })

            for (var ii = 0; ii < filter.length; ii++) {
                if (filter[ii].flagPickupChangeRequired == true && filter[ii].flagEquipmentProgrammingSequence == false) {
                    kanbanColumnsSelectedAux.push(filter[ii]);
                }
            }
        }
        return kanbanColumnsSelectedAux;
    }

    const listChangeSelect = [];

    function checkValue(e) {
        var value = e.target.value;
        if (e.target.checked) {
            listChangeSelect.push(e.target.id);
        }
        else if (listChangeSelect.length > 0) {
            const index = listChangeSelect.findIndex((f) => f !== e.target.id);
            listChangeSelect.splice(index, 1);
        }
    }

    useEffect(() => {
        function updateBoard() {
            const currentColumns = [];
            for (let i = 0; i < 7; i++) {
                const momentNewDate = moment(currentDay).add(i, "days");
                const dataset = kanbanColumnsData.find(x => x.id === momentNewDate.format("YYYY-MM-DD"));
                const datasetExternal = externalBranchPickupList?.filter(dataValue => findExternalBranchPickupByDate(dataValue, momentNewDate)) || [];
                let dataFinal = [];
                if (dataset?.data) {
                    dataFinal = dataset?.data;
                }
                if (datasetExternal) {
                    dataFinal = [...dataFinal, ...datasetExternal];
                }
                currentColumns.push(generateKanbanColumn(dataFinal, momentNewDate.toDate(), i));
            }
            setControlledBoard({ ...controlledBoard, columns: currentColumns });
        }

        updateBoard();
    }, [kanbanColumnsData, t]);

    useEffect(() => {
        const initialize = async () => {

            await fetchProgramEquipmentContingencyConfig();

            await fetchRecentPickupAlertConfig();

            EquipmentService.getAll().then((response: any) => {
                if (response.success) {
                    const sort = response.result
                        .filter(e => !e.parentEquipmentId) // null, undefined ou ''
                        .sort((a, b) => a.codeEquipment.localeCompare(b.codeEquipment));

                    let options = [];
                    sort.forEach(element => {
                        options.push({ value: element.id, label: element.codeEquipment });
                    });
                    setEquipments(options);
                } else {
                    setEquipments([]);
                }
            });

            BranchService.getAllList().then((response: any) => {
                if (response.success) {
                    const branchList = response.result?.datasets?.filter(
                        (dataset) => dataset.dataset === "branch"
                    ) || [];

                    const sortbranchList = branchList[0]?.data?.sort((a, b) =>
                        a.fullName.localeCompare(b.fullName)
                    ) || [];

                    const options = sortbranchList.map(element => ({
                        value: element.id,
                        label: element.fullName
                    }));

                    setBranches(options);
                } else {
                    setBranches([]);
                }
            });

            PickupStatusService.getAll().then((response: any) => {
                if (response.success) {
                    setCollectionForecastColor(response.result.filter((item) => { return item.id == 0 })[0].pickupColor)
                    setInPlanCollectionServiceColor(response.result.filter((item) => { return item.id == 1 })[0].pickupColor)
                    setPlanedCollectionServiceColor(response.result.filter((item) => { return item.id == 4 })[0].pickupColor)
                    setScheduledCollectionServiceColor(response.result.filter((item) => { return item.id == 12 })[0].pickupColor)
                    setExecutedCollectionServiceColor(response.result.filter((item) => { return item.id == 7 })[0].pickupColor)
                }
                else {
                    setCollectionForecastColor('')
                    setInPlanCollectionServiceColor('')
                    setPlanedCollectionServiceColor('')
                    setScheduledCollectionServiceColor('')
                    setExecutedCollectionServiceColor('')
                }
            });

            const configMinValue: any = await ConfigService.GetByKeyAndLocale("PERC_MIN_REQUEST_JUSTIF");
            setPercentMinimalValue(configMinValue?.result?.configValue);

            const configMaxValue: any = await ConfigService.GetByKeyAndLocale("PERC_MAX_REQUEST_JUSTIF");
            setPercentMaxValue(configMaxValue?.result?.configValue);



            createInitialBoard();
        };
        initialize();

    }, []);

    // Definindo as opções de porcentagem
    const percentageOptions = [
        { value: 50, label: "50%" },
        { value: 60, label: "60%" },
        { value: 70, label: "70%" },
        { value: 80, label: "80%" },
        { value: 90, label: "90%" },
        { value: 100, label: "100%" }
    ];

    const ListYesNo = [
        { value: 1, label: t("YES") },
        {
            value: 2, label: t("NO")
        }
    ]

    const handleCancellationRequestClick = () => {
        // Filtra os itens onde o 4º elemento não é 'true'
        const filteredCardSelecteds = cardSelecteds.filter((item) => {
            const itemSplitted = item.split("__");
            return itemSplitted[4] !== "true" && itemSplitted[5] === "#FFFF99"; // Ignora os itens com o 4º elemento 'true'
        });

        // Gera os dados de pickupStatusData com base em cardSelecteds
        const pickupStatusData = filteredCardSelecteds.map(item => {
            const itemSplitted = item.split("__");
            return {
                id_equipment: itemSplitted[1],
                pickup_date: itemSplitted[2],
                code_equipment: itemSplitted[3],
                equipment_pickup_id: itemSplitted[6],
                dash_action: "CANCELLATION_REQUEST",
                pickup_change_required: listChangeSelect.some((f) => f === item)
            };
        });

        setSelectedEquipments(pickupStatusData)

        // Abre o modal
        setShowCancellationModal(true);
    };



    const handleConfirmCancellation = async () => {
        setLoading(true); // Exibe o estado de carregamento

        // Filtra os itens onde o 4º elemento não é 'true'
        const filteredCardSelecteds = cardSelecteds.filter((item) => {
            const itemSplitted = item.split("__");
            return itemSplitted[4] !== "true" && itemSplitted[5] === "#FFFF99"; // Ignora os itens com o 4º elemento 'true'
        });


        // Processa os dados selecionados em cardSelecteds
        const cancellationData = filteredCardSelecteds.map(item => {
            const itemSplitted = item.split("__");
            return {
                id_equipment: itemSplitted[1],
                pickup_date: itemSplitted[2],
                code_equipment: itemSplitted[3],
                equipment_pickup_id: itemSplitted[6],
                dash_action: "CANCELLATION_REQUEST",
                pickup_change_required: listChangeSelect.some((f) => f === item)
            };
        });

        // Configura os parâmetros da requisição
        let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [{
                ...DatasetDefault,
                dataset: 'dashboard_branch_cancellation',
                data: cancellationData
            }]
        };

        try {
            // Envia a requisição para o serviço
            const response: any = await DashboardBranchService.requestCancellationSiga(requestParams);

            if (response.success === true && response.result) {
                const dataset = _.last(_.filter(response.result.datasets, { dataset: "dashboard_branch" }));

                if (dataset?.data) {
                    for (let i = 0; i < dataset.data.length; i++) {
                        updateCardByData(dataset.data[i]); // Atualiza os cards com os dados retornados
                    }
                }
                ToastService.success(t('DASHBOARD_BRANCH.CANCELLATION_SUCCESS')); // Mensagem de sucesso
                // Chama a função handleSearch para recarregar os dados da tela
                await handleSearch();
            } else {
                ToastService.error(t('DASHBOARD_BRANCH.CANCELLATION_FAILED')); // Mensagem de erro
            }
        } catch (error) {
            console.error("Erro na solicitação de cancelamento:", error);
            ToastService.error(t('DASHBOARD_BRANCH.CANCELLATION_FAILED')); // Mensagem de erro
        } finally {
            setLoading(false); // Remove o estado de carregamento
            setLoading(false); // Remove o estado de carregamento
            setShowCancellationModal(false); // Fecha o modal
            setCardSelecteds([]); // Limpa os itens selecionados

        }

        setCardSelecteds([]); // Limpa os itens selecionados
        setLoading(false); // Remove o estado de carregamento
        setShowCancellationModal(false); // Fecha o modal
    };



    const handleCloseCancellationModal = () => {
        setShowCancellationModal(false); // Atualiza o estado para fechar o modal
    };

    let selectedSet = new Set();

    // Se selectedEquipmentsForAssociationItems estiver nulo, indefinido ou vazio → retorna Set vazio
    if (Array.isArray(selectedEquipmentsForAssociationitems) && selectedEquipmentsForAssociationitems.length > 0) {
    
    selectedEquipmentsForAssociationitems.forEach(item => {
        // equipment principal
        if (item.equipment != null) {
        selectedSet.add(Number(item.equipment));
        }

        // associados
        if (Array.isArray(item.associated)) {
        item.associated.forEach(a => selectedSet.add(Number(a)));
        }
    });
    }

    const hasRecentAlertMatch = (kanbanColumnsData ?? []).some(day =>
    (day?.data ?? []).some(e =>
        e?.flagRecentPickupAlert === true &&
        selectedSet.has(Number(e?.codeEquipment))
    )
);

    return (
        <>
            <HeaderList title={t("DASHBOARD_BRANCH.TITLE_LIST")} />
            {/* {JSON.stringify(kanbanColumnsData)} */}
            <CustomModal
                Title={t('DASHBOARD_BRANCH.JUSTIFICATION')}
                Message={(
                    <>
                        <Alert key={showJustificationModal.color} variant={showJustificationModal.color}>
                            {showJustificationModal.alertMessage}
                        </Alert>
                        <Form.Group style={showJustify ? { display: '' } : { display: 'none' }} >
                            <Form.Label>{t('DASHBOARD_BRANCH.JUSTIFY_THE_CHANGE')}</Form.Label>
                            <Form.Control
                                name='justification'
                                id='justification'
                                as="textarea" rows={3}
                                onChange={handleChangeJustification}
                                disabled={isLoading}
                                isInvalid={!showJustificationModal.justification}
                                value={showJustificationModal.justification}
                                maxLength={1000}
                            />
                            <Form.Control.Feedback type="invalid" style={{ position: "relative" }}>
                                Campo obrigatório.
                            </Form.Control.Feedback>
                        </Form.Group>
                    </>
                )}
                close={handleCloseModal}
                cancel={t('CANCEL')}
                show={showJustificationModal ? showJustificationModal.show : false}>
                <Button variant='primary' onClick={saveJustification}
                    disabled={(!showJustificationModal.justification || showJustificationModal.justification.trim().length == 0) && showJustify == true}>
                    {t('JUSTIFY')}
                </Button>
            </CustomModal>

            <CancellationRequestModal
                show={showCancellationModal}
                close={handleCloseCancellationModal}
                onConfirm={handleConfirmCancellation}
                selectedEquipments={selectedEquipments} // Lista de equipamentos selecionados
                isLoading={isLoading}
            />


            <CustomModal
                Title={t('DASHBOARD_BRANCH.SCHEDULE')}
Message={
        <>

            {
                (hasRecentAlertMatch && enableRecentPickupAlert) ? (
                    <p>{t('CONFIG.ALERT_RECENT_PICKUP_ALERT')}</p>
                ) : (
                    <p>{t('DASHBOARD_BRANCH.SCHEDULE_ANSWER')}</p>
                )
            }
            

            {selectedEquipmentsForAssociationitems?.some(item => item.associated.length > 0) && (
            <>
                <hr />
                <p>
                {t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_ASSOCIATION_SCHEDULE_MODAL_MESSAGE")}
                </p>

                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr>
                    <th style={{ textAlign: 'left', padding: '4px' }}>
                        {t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_SELECTED")}
                    </th>
                    <th style={{ textAlign: 'left', padding: '4px' }}>
                        {t("MULTI_EQUIPMENT_GROUP.EQUIPMENT_ASSOCIATED")}
                    </th>
                    </tr>
                </thead>
                <tbody>
                    {selectedEquipmentsForAssociationitems.map((item) => (
                    <tr key={item.equipment}>
                        <td style={{ padding: '4px' }}>{item.equipment}</td>
                        <td style={{ padding: '4px' }}>{item.associated.join(', ')}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </>
            )}
        </>
        }


                close={handleCloseModal}
                cancel={t('CANCEL')}
                show={showScheduleModal}
                MessageChange={t('CONFIG.EQUIPMENT_CHANGE_REQUIRED_MODAL')}
                PickupChangeRequired='true'
                ListChange={typeof kanbanColumnsSelected() != 'undefined' ? kanbanColumnsSelected() : 'error'}
                checkValue={checkValue}
            //ListChange = {typeof kanbanColumnsData[0] != 'undefined' ? kanbanColumnsData[0] : 'error'}

            >
                {
                    <div>
                        <Button variant='primary' disabled={isLoading || false} onClick={saveEquipmentProgram}>
                            {t('CONFIRM')}
                        </Button>
                    </div>
                }

            </CustomModal>

            <ModalAlertList
                Title={t('MODULE_ALERT.ALERTS')}
                ListAlert={alertList}
                ButtonCloseLabel={`${t('MODULE_ALERT.CLOSE')}`}
                HandleClose={handleCloseModalAlertList}
                Show={modalAlertListShow}>
            </ModalAlertList>

            <ModalGeneralInformation
                close={handleCloseModalGeneralInformation}
                show={showModalGeneralInformation}
                pdfFileName={"GeneralInformationDashboardBranch.pdf"}
                ButtonCloseLabel={`${t('MODULE_ALERT.CLOSE')}`}>
            </ModalGeneralInformation>

            <Form className="form-fixed">
                <Row>
                    <Col sm={14} md={8} lg={8}>
                        <Row className="mb-3 align-items-left">
                            <Col sm={2}>
                                <Form.Group>
                                    <Form.Floating>
                                        <Select
                                            placeholder={t("FILTER.EQUIPMENT")}
                                            options={equipments}
                                            value={equipmentSeleted}
                                            onChange={handleChangeEquipment} />
                                    </Form.Floating>
                                </Form.Group>
                            </Col>

                            <Col sm={2}>
                                <Form.Group>
                                    <Form.Floating>
                                        <Select
                                            placeholder={t("FILTER.BRANCH")}
                                            options={branches}
                                            value={branchSeleted}
                                            isSearchable={false} // Desativa a funcionalidade de pesquisa
                                            onChange={handleChangeBranch} />
                                    </Form.Floating>
                                </Form.Group>
                            </Col>

                            <Col sm={2}>
                                {/* Input Cliente - Atenção na funcionalidade stopPropagation responsavel por impedir do acordeon expadir ao clicar*/}
                                <div onClick={(e) => e.stopPropagation()}>
                                    <Form.Floating>
                                        <Form.Control
                                            name='customer'
                                            id='customer'
                                            type='text'
                                            placeholder={t(`FILTER.CLIENT`)}
                                            className='form-control'
                                            onChange={(e) => {
                                                setDatasetDashboardBranch({
                                                    ...datasetDashboardBranch,
                                                    filters: {
                                                        ...datasetDashboardBranch.filters,
                                                        customer: [e.target.value],
                                                    },
                                                });
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleSearch();
                                                }
                                            }}
                                            value={
                                                datasetDashboardBranch?.filters?.customer
                                                    .length > 0
                                                    ? datasetDashboardBranch.filters.customer[0]
                                                    : ""
                                            }
                                        />
                                        <label>{t("FILTER.CUSTOMER")}</label>
                                    </Form.Floating>
                                </div>
                            </Col>

                            <Col sm={2}>
                                <Form.Group>
                                    <Form.Floating>
                                        <Select
                                            placeholder={t("DASHBOARD_BRANCH.STATUS")}
                                            options={[
                                                {
                                                    value: 1,
                                                    label: t("DASHBOARD_BRANCH.IN_PLAN_COLLECTION_SERVICE"),
                                                },
                                                {
                                                    value: 4,
                                                    label: t("DASHBOARD_BRANCH.PLANNED_COLLECTION_SERVICE_"),
                                                },
                                                {
                                                    value: 12,
                                                    label: t("DASHBOARD_BRANCH.SCHEDULED_COLLECTION_SERVICE_"),
                                                },
                                                {
                                                    value: 7,
                                                    label: t("DASHBOARD_BRANCH.EXECUTED_COLLECTION_SERVICE_"),
                                                },
                                            ]}
                                            value={statusValueSelected}
                                            onChange={handleChangeStatusValue}
                                            isSearchable={false} // Desativa a funcionalidade de pesquisa
                                            components={{
                                                Option: CustomOption,
                                                SingleValue: CustomValue,
                                            }}
                                        />
                                    </Form.Floating>
                                </Form.Group>
                            </Col>

                            <Col sm={2}>
                                <Form.Group>
                                    <Form.Floating>
                                        <Select
                                            placeholder={t("DASHBOARD.FILTER_EQUIPMENT_IMPOSITION")}
                                            options={ListYesNo}
                                            value={ListYesNo.find(option => option.value === filterForced) || null}
                                            onChange={(selectedOption) => setFilterForced(selectedOption ? selectedOption.value : null)}
                                            isSearchable={false}
                                        />
                                    </Form.Floating>
                                </Form.Group>
                            </Col>

                            <Col sm={2}>
                                <Form.Group>
                                    <Form.Floating>
                                        <Select
                                            placeholder={t("DASHBOARD_BRANCH.PERCENTAGE")}
                                            options={percentageOptions}  // Usando as opções de porcentagem definidas acima
                                            value={percentageOptions.find(option => option.value === percentageBalanceOnline) || null}
                                            onChange={(selectedOption) => setPercentageBalanceOnline(selectedOption ? selectedOption.value : null)}
                                            isSearchable={false}
                                        />
                                    </Form.Floating>
                                </Form.Group>
                            </Col>

                        </Row>
                        <Row className="align-items-left">
                            <Col xs="auto">
                                <ButtonSearch disabled={isLoading} isLoading={isLoading} onClick={handleSearch} />&nbsp;&nbsp;&nbsp;
                                <ButtonClean onClick={async (e) => handleClean()} isLoading={isLoading} />
                                {desactiveProgramConfig ? (
                                    <>
                                        <ButtonProgram
                                            text={t("DASHBOARD_BRANCH.BUTTON_PROGRAM")}
                                            isLoading={isLoading}
                                            titlePopOver={t("MODAL_DISABLED_PROGRAM_EQUIPMENT.TITLE")}
                                        />
                                    </>) : (
                                    <>
                                        {(user.profile.profileName === "reader" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? ( // Verifica se o perfil é "reader" ou adm_reader
                                            <>
                                                <Button
                                                    disabled={true} // Desabilita o botão se o perfil for "reader" ou adm_reader
                                                    style={{ marginLeft: 10 }}
                                                >
                                                    {t("DASHBOARD_BRANCH.BUTTON_PROGRAM")}
                                                </Button>
                                                <span>{'\u00A0'}{'\u00A0'}</span> {/* Adiciona dois espaços não quebráveis */}
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    onClick={handleProgramClick}
                                                    style={{ marginLeft: 10 }}
                                                    disabled={desactiveProgramConfig ? desactiveProgramConfig : !cardSelecteds.length}
                                                >
                                                    {t("DASHBOARD_BRANCH.BUTTON_PROGRAM")}
                                                </Button>
                                                <span>{'\u00A0'}{'\u00A0'}</span> {/* Adiciona dois espaços não quebráveis */}
                                            </>
                                        )}
                                    </>
                                )}

                                {desactiveProgramConfig ? (
                                    <>
                                        <ButtonProgram
                                            text={t("DASHBOARD_BRANCH.BUTTON_CANCELLATION_REQUEST")}
                                            isLoading={isLoading}
                                            titlePopOver={t("MODAL_DISABLED_CANCELLATION_REQUEST.TITLE")}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {(user.profile.profileName === "reader" || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                                            <>
                                                <Button
                                                    disabled={true} // Desabilita o botão se o perfil for "reader" ou "adm_reader"
                                                    style={{ marginLeft: 10 }}
                                                >
                                                    {t("DASHBOARD_BRANCH.BUTTON_CANCELLATION_REQUEST")}
                                                </Button>
                                                <span>{'\u00A0'}{'\u00A0'}</span> {/* Adiciona dois espaços não quebráveis */}
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    onClick={handleCancellationRequestClick} // Função ao clicar no botão
                                                    style={{ marginLeft: 10 }}
                                                    disabled={
                                                        desactiveProgramConfig
                                                            ? desactiveProgramConfig
                                                            : !cardSelecteds.length ||
                                                            cardSelecteds.every(item => {
                                                                const itemSplitted = item.split("__");
                                                                return itemSplitted[4] === "true" || itemSplitted[5] !== "#FFFF99";
                                                            })
                                                    }
                                                >
                                                    {t("DASHBOARD_BRANCH.BUTTON_CANCELLATION_REQUEST")}
                                                </Button>
                                                <span>{'\u00A0'}{'\u00A0'}</span> {/* Adiciona dois espaços não quebráveis */}
                                            </>
                                        )}
                                    </>
                                )}

                                <DropdownButtonExport onClick={(type: string) => FileExportService.Export({ ...RequestInputOutputParamsModelDefault, datasets: [{ ...datasetDashboardBranch, filters: { ...datasetDashboardBranch.filters, forced: [filterForced], pickup_date: _.map([0, 1, 2, 3, 4, 5, 6], (val) => { return moment(currentDay).add(val, "days").format("YYYY-MM-DD") }) } }] }, "DashboardBranch", type)} />
                                {/* &nbsp;&nbsp;&nbsp; */}
                                {/* <Button onClick={showAlerts}><span>{t("ALERTS")}</span></Button> */}
                                <ButtonInfo
                                    disabled={isLoading}
                                    isLoading={isLoading}
                                    onClick={showGeneralInformation}
                                    titlePopOver={t("MODAL_GENERAL_INFORMATION.TITLE_OPERATOR")}
                                />

                            </Col>

                        </Row>
                    </Col>
                    <Col sm={12} md={3} lg={3} style={{ marginTop: '-35px' }}>
                        <h4>{t("DASHBOARD_BRANCH.COLOR_LEGEND_TITTLE")}</h4>
                        <Badge style={{ backgroundColor: inPlanCollectionServiceColor, color: inPlanCollectionServiceColor }} bg="">#</Badge><b> {t("DASHBOARD_BRANCH.IN_PLAN_COLLECTION_SERVICE")}</b><br></br>
                        <Badge style={{ backgroundColor: planedCollectionServiceColor, color: planedCollectionServiceColor }} bg="">#</Badge><b> {t("DASHBOARD_BRANCH.PLANNED_COLLECTION_SERVICE_")}</b><br></br>
                        <Badge style={{ backgroundColor: scheduledCollectionServiceColor, color: scheduledCollectionServiceColor }} bg="">#</Badge><b> {t("DASHBOARD_BRANCH.SCHEDULED_COLLECTION_SERVICE_")}</b><br></br>
                        <Badge style={{ backgroundColor: executedCollectionServiceColor, color: executedCollectionServiceColor }} bg="">#</Badge><b> {t("DASHBOARD_BRANCH.EXECUTED_COLLECTION_SERVICE_")}</b><br></br>
                    </Col>
                </Row>
            </Form>

            <Row>
                <Col sm={12}>
                    <hr />
                </Col>
            </Row>

            <Row>
                <Col sm={12}>
                    <h5>{t("DASHBOARD_BRANCH.DAILY_CAPACITY_FORECAST")}</h5>
                </Col>

                <Col sm={6}>
                    <Button className="me-2" onClick={() => { addDayToPeriod(-1) }}>{' < '}</Button><Button className="me-2" onClick={() => { addDayToPeriod(1) }}>{' > '}</Button>{renderPeriodDescription()}
                </Col>
            </Row>




            <Row className="div-grid">
                <Col sm={12} >
                    <div className="div-header">
                        <table id="basic" >
                            <tr>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(0)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(1)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(2)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(3)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(4)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(5)}</div>
                                </td>
                                <td className="react-kanban-column-fake controle">
                                    <div className="bg-header">{renderPeriodDescriptionFake(6)}</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Col>

                <Col sm={12}>
                    <div className="div-content">
                        <Board
                            onCardDragEnd={handleCardMove}
                            disableColumnDrag
                            disableCardDrag={movementCards}
                            renderCard={(props, { dragging }) => (<CustomKanbanCard {...props} cardSelecteds={cardSelecteds} onCardClick={handleCardClick} enableCard={enableCard} showJustForced={filterForced} />)}
                            children={controlledBoard} />
                    </div>
                </Col>
            </Row>

        </>
    );
};